module.exports = __webpack_public_path__ + "static/media/background.c43e2ad8.png";